/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState, useRef } from "react";
import {
  uploadNewsLetter,
  getNewsLetter,
  deleteNewsLetter,
} from "./ManageNewsLetter.js";

const deptNewsLetterManager = () => {
  const [title, setTitle] = useState("");
  const [titleDropdownOpen, setTitleDropdownOpen] = useState(false);
  const [pdf, setPdf] = useState(null);
  const [newsLetterList, setNewsLetterList] = useState([]);
  const dropdownRef = useRef(null);

  const titleOptions = ["CSE News Letter", "MOM News Letter"];

  const fetchNewsLetter = async () => {
    try {
      const data = await getNewsLetter();
      setNewsLetterList(data || []);
    } catch (error) {
      console.error("Failed to fetch laboratory:", error);
      setNewsLetterList([]);
    }
  };

  useEffect(() => {
    fetchNewsLetter();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setTitleDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleUpload = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("pdf", pdf);

    try {
      await uploadNewsLetter(formData);
      fetchNewsLetter();
      setTitle("");
      setPdf(null);
    } catch (error) {
      alert("Error uploading newsletter update.");
    }
  };

  const handleDelete = async (id) => {
    if (
      window.confirm("Are you sure you want to delete this laboratory update?")
    ) {
      await deleteNewsLetter(id);
      fetchNewsLetter();
    }
  };

  const selectTitle = (selectedTitle) => {
    setTitle(selectedTitle);
    setTitleDropdownOpen(false);
  };

  const openDropdown = () => {
    setTitleDropdownOpen(true);
  };

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-center mb-4">
        Department NewsLetter Management
      </h1>

      <form
        onSubmit={handleUpload}
        className="mb-6 p-4 bg-white rounded-lg shadow"
      >
        <h2 className="text-lg font-semibold mb-2">
          Upload Department NewsLetter & Updates
        </h2>
        <div className="relative mb-2" ref={dropdownRef}>
          <div className="flex items-center">
            <input
              type="text"
              placeholder="Choose Department"
              value={title}
              readOnly
              onClick={openDropdown}
              className="w-full p-2 border rounded cursor-pointer"
              required
            />
            <button
              type="button"
              onClick={openDropdown}
              className="absolute right-2 bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded"
            >
              ▼
            </button>
          </div>
          {titleDropdownOpen && (
            <div className="absolute z-10 w-full mt-1 bg-white border rounded shadow-lg">
              {titleOptions.map((option, index) => (
                <div
                  key={index}
                  className="p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => selectTitle(option)}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
        <label className="flex between space-x-2">
          <span className="text-sm font-medium">Attach PDF</span>
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setPdf(e.target.files[0])}
            className="mb-2"
          />
        </label>
        <button
          type="submit"
          className="bg-teal-400 hover:bg-teal-500 text-white px-4 py-2 rounded"
        >
          Upload
        </button>
      </form>

      <h2 className="text-lg font-semibold mb-2">Department NewsLetter List</h2>
      {!newsLetterList || newsLetterList.length === 0 ? (
        <p className="text-center">No NewsLetter PDFs available.</p>
      ) : (
        <ul className="space-y-3">
          {newsLetterList.map((item) => (
            <li
              key={item._id}
              className="p-4 bg-white rounded-lg shadow flex justify-between items-center"
            >
              <div>
                <h3 className="font-bold">{item.title}</h3>
                <a
                  href={`${process.env.REACT_APP_BASE_URL}/${item.pdf}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500"
                >
                  View PDF
                </a>
              </div>
              <button
                onClick={() => handleDelete(item._id)}
                className="bg-teal-400 text-white px-3 py-1 rounded"
              >
                Delete
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default deptNewsLetterManager;
